import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducer from '../reducers'
import { persistStore } from 'redux-persist'

const middleware = [thunk]
const reduxdevTools = []
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger())
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
    reduxdevTools.push(window.__REDUX_DEVTOOLS_EXTENSION__())
}
export const store = createStore(
  reducer,
  compose(applyMiddleware(...middleware), ...reduxdevTools)
)

export const persistor = persistStore(store)

export default { store, persistor }
